export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9323.0ad918fc.jpg";